import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from 'react-router';
import { currencyConvertor, getMode, isEclipseOpsTruck } from '../../../../Utils/Utility';
import BilledHeader from './BilledHeader';
import { injectIntl } from 'react-intl';
import { EclipseServiceFeeAction } from '@mobile-dev/platform/common/redux/actions/EclipseServiceFeeAction'
import { clearError, clearTransaction, clearEclipseServiceFee, clearTTConvenienceFee } from '@mobile-dev/platform/common/redux/actions/CommonAction';
import Loader from '../../../Common/Loader';
import { TTConvenienceFeeAction } from '@mobile-dev/platform/common/redux/actions/EclipseServiceFeeAction'

function PaymentConfirmation({ intl, ...props }) {
    const history = useHistory();
    const { formatMessage } = intl;
    const selection = props.location.state.selection;
    const remainingAmount = props.location.state.remainingAmount
    const id = props.match.params.id;
    const paymentmethods = props.location.state.paymentmethods;
    const billedPo = useSelector(state => state.billed.billedPo);
    const eclipseServiceFee = useSelector(state => state.getEclipseServiceFee)
    const [eclipseFee, setEclipseFee] = useState(0)
    ///totalremainig = total_bill_amount +unload_bill_amount
    const dispatch = useDispatch()
    const loads = billedPo.loads
    const load = loads.find(load => load.load_id === id);
    const warehouse_id = load?.warehouse_id;
    const [isLoading, setIsLoading] = useState(false)
    let tin = load.tax_id;
    const TTConvenienceFee = useSelector(state => state.getTTConvenienceFee)
    const [data, setData] = useState(load)
    const [total_bill_amount, settotal_bill_amount] = useState(data.total_bill_amount)
    const [total_paid, settotal_paid] = useState(data.total_paid)
    const [amount, setAmount] = useState(props.location.state.amount);
    const [updatedBillAmount, setUpdatedBillAmount] = useState(null)

    useEffect(() => {
        if (load && isEclipseOpsTruck(load)) {
            getEclipseServiceFee()
        } else {
            getTTConvenienceFee()
        }
    }, [])

    useEffect(() => {
        if (data) {
            settotal_bill_amount(data.total_bill_amount)
            settotal_paid(data.total_paid)
        }

    }, [data]);

    useEffect(() => {
        if (TTConvenienceFee?.convenienceFee) {
            const { UpdatedBillAmount } = TTConvenienceFee?.convenienceFee
            setIsLoading(false)
            setTimeout(() => {
                // setData({ ...data, total_bill_amount: UpdatedBillAmount })
                setAmount(UpdatedBillAmount)
                setUpdatedBillAmount(UpdatedBillAmount)
                dispatch(clearTTConvenienceFee())
            }, 500)

        }
        if (TTConvenienceFee?.convenienceFeeError) {
            dispatch(clearError())
            getTTConvenienceFee()
        }
    }, [TTConvenienceFee])

    const getTTConvenienceFee = () => {
        const initiateGetServiceFee = (type) => {
            const body = {
                "IDWarehouse": data?.warehouse_id,
                "paymentMode": getMode(type),
                "load_id": data?.load_id,
                "paymentType": selection,
                "amount": null
            }
            setIsLoading(true)
            dispatch(TTConvenienceFeeAction(body))
        }

        switch (paymentmethods) {
            case "Relay":
                return initiateGetServiceFee("RELAY")
            case "ComData":
                return initiateGetServiceFee("COMDATA")
            case "EFS":
                return initiateGetServiceFee("EFS")
            case "T-Chek":
                return initiateGetServiceFee("TCHEK")
            case "CreditCard":
                return initiateGetServiceFee("CREDITCARD")
            case "Insta-Money":
                return initiateGetServiceFee("INSTAMONEY")
            case "Us-Bank":
                return initiateGetServiceFee("USBANK")
        }
    }

    const getAmount = () => {
        if (isEclipseOpsTruck(load)) {
            return parseFloat(parseFloat(amount) + parseFloat(eclipseFee)).toFixed(2)
        } else {
            return amount
        }
    }

    const getTotalCharges = () => {
        if (isEclipseOpsTruck(load)) {
            return parseFloat(parseFloat(amount) + parseFloat(eclipseFee)).toFixed(2)
        } else {
            if (updatedBillAmount) {
                return amount
            } else {
                return 0.00
            }
        }
    }



    useEffect(() => {
        if (eclipseServiceFee?.serviceFee) {
            setIsLoading(false)
            const { FeeType, Fee } = eclipseServiceFee?.serviceFee
            const fee = FeeType === "CCARD" ? parseFloat(parseFloat(amount) * Fee) : parseFloat(Fee)
            setEclipseFee(fee)
            dispatch(clearEclipseServiceFee())
        }
        if (eclipseServiceFee?.error) {
            setIsLoading(false)
            dispatch(clearError())
            getEclipseServiceFee()
        }
    }, [eclipseServiceFee])

    const getEclipseServiceFee = () => {
        const getMode = (type) => {
            if (type === "RELAY" || type === "COMDATA" || type === "EFS" || type === "TCHEK") {
                return "CHECK"
            } else if (type === "CREDITCARD") {
                return "CCARD"
            }

        }
        const initiateGetServiceFee = (type) => {
            const body = {
                "locId": warehouse_id,
                "feeType": getMode(type)
            }
            setIsLoading(true)
            dispatch(EclipseServiceFeeAction(body))
        }
        switch (paymentmethods) {
            case "Relay":
                return initiateGetServiceFee("RELAY")
            case "ComData":
                return initiateGetServiceFee("COMDATA")
            case "EFS/WEX":
                return initiateGetServiceFee("EFS")
            case "EFS":
                return initiateGetServiceFee("EFS")
            case "T-Chek":
                return initiateGetServiceFee("TCHEK")
            case "CreditCard":
                return initiateGetServiceFee("CREDITCARD")
        }
    }

    const handleClick = () => {
        let updatedTrasactionObject
        if (isEclipseOpsTruck(load)) {
            updatedTrasactionObject = { bankName: paymentmethods, id, remainingAmount, selection, total_bill_amount, paymentmethods, amount: parseFloat(parseFloat(eclipseFee) + parseFloat(amount)).toFixed(2), serviceFee: parseFloat(eclipseFee).toFixed(2) }

        } else {
            updatedTrasactionObject = { amount, id, remainingAmount, selection, total_bill_amount, paymentmethods, bankName: paymentmethods, originalAmount: props.location.state.amount }
        }

        if (paymentmethods === "CreditCard") {
            history.push({ pathname: `/creditcard/${id}`, state: updatedTrasactionObject });
        }
        else if (paymentmethods === "Relay") {
            history.push({ pathname: `/relay/${id}`, state: updatedTrasactionObject });
        }
        else if (paymentmethods === "ComData") {
            history.push({ pathname: `/comCheck/${id}`, state: updatedTrasactionObject });
        }
        else if (paymentmethods === "Insta-Money") {
            history.push({ pathname: `/instaMoney/${id}`, state: updatedTrasactionObject })
        }
        else if (paymentmethods === "Us-Bank") {
            history.push({ pathname: `/usBank/${id}`, state: updatedTrasactionObject })
        }
        else if (paymentmethods === "EFS") {
            history.push({ pathname: `/efs/${id}`, state: updatedTrasactionObject })
        }

        else if (paymentmethods === "T-Chek") {
            history.push({ pathname: `/tCheck/${id}`, state: updatedTrasactionObject })
        }

    }
    return (
        <div className="content-page">
            <div className="content">
                <div className="contest_input_block">
                    <div className="contest_preview">
                        <BilledHeader path={`/selectPayment/${id}`} amount={amount} remainingAmount={remainingAmount} selection={selection} total_bill_amount={total_bill_amount} tin={tin} />
                        <div className="container_block" style={{ padding: '40px' }}>
                            <div id="smartwizard" className="sw sw-theme-dots sw-justified">
                                <div id="step-4" className="tab-pane" role="tabpanel" aria-labelledby="step-4">
                                    <section>
                                        <h4 className="mb-3 txtwhite">{formatMessage({ id: "app.confirm_payment" })}</h4>
                                        <div className="row">
                                            <div className="col-sm-7 col-xxl-6">


                                                <div className="row">
                                                    <div className="form-group col-sm-6">
                                                        <span className="gray_label">{formatMessage({ id: "app.control_number" })}</span>
                                                        <p>{load.load_control_num}</p>
                                                    </div>
                                                    <div className="form-group col-sm-6">
                                                        <span className="gray_label">{formatMessage({ id: "app.total_charges" })}</span>
                                                        <p className="text-danger"><b className="text-danger">${getTotalCharges()}</b></p>

                                                    </div>
                                                    {/* {
                                                        isEclipseOpsTruck(load)
                                                            ? <div className="form-group col-sm-6">
                                                                <span className="gray_label">{formatMessage({ id: "app.bill_amount" })}</span>
                                                                <p className="text-danger"><b className="text-danger">${total_bill_amount}</b></p>

                                                            </div>
                                                            : <div className="form-group col-sm-6">
                                                                <span className="gray_label">{formatMessage({ id: "app.total_charges" })}</span>
                                                                <p className="text-danger"><b className="text-danger">${total_bill_amount}</b></p>

                                                            </div>
                                                    } */}

                                                </div>


                                                <div className="row">
                                                    {
                                                        !isEclipseOpsTruck(load) &&
                                                        <div className="form-group col-sm-6">
                                                            <span className="gray_label">{formatMessage({ id: "app.payment_method" })}</span>
                                                            <p>{paymentmethods}</p>
                                                        </div>
                                                    }

                                                    {/* {
                                                        isEclipseOpsTruck(load) &&
                                                        <div className="form-group col-sm-6">
                                                            <span className="gray_label">{formatMessage({ id: "app.service_fee" })}</span>
                                                            <p className="text-danger"><b className="text-danger">${serviceFee}</b></p>

                                                        </div>

                                                    } */}
                                                    <div className="form-group col-sm-6">
                                                        <span className="gray_label">{formatMessage({ id: "app.payable_amount" })}</span>
                                                        <p><b className="remaining_amt">$ {getAmount()}</b></p>
                                                    </div>



                                                </div>

                                                <div className="row">



                                                    <div className="form-group col-sm-6">
                                                        <span className="gray_label">{formatMessage({ id: "app.payment_type" })}</span>
                                                        <p>{selection}</p>

                                                    </div>
                                                    <div className="form-group col-sm-6">
                                                        <span className="gray_label">{formatMessage({ id: "app.payment_remaining" })}</span>
                                                        <p><strong className="remaining_amt">$ {currencyConvertor(remainingAmount)}</strong></p>

                                                    </div>
                                                    {
                                                        isEclipseOpsTruck(load) &&
                                                        <div className="form-group col-sm-6">
                                                            <span className="gray_label">{formatMessage({ id: "app.payment_method" })}</span>
                                                            <p>{paymentmethods}</p>
                                                        </div>
                                                    }

                                                </div>
                                            </div>

                                            <div className="col-sm-2 col-xxl-2">
                                                <div className="row">
                                                    <div className="form-group col-sm-12">
                                                        <span className="gray_label">{formatMessage({ id: "app.po" })}</span>
                                                        {load.pos.map((po, index) => {
                                                            return (
                                                                <p key={index}>{po.po_number}</p>
                                                            )
                                                        })}
                                                    </div>
                                                </div>

                                            </div>
                                        </div>

                                    </section>
                                </div>
                                <div className="toolbar toolbar-bottom" role="toolbar" style={{ textAlign: 'right' }}>

                                    <button className="btn sw-btn-next btn-chartreuse float-right w-auto" type="button" style={{ width: 'auto !important' }} onClick={handleClick}>{formatMessage({ id: "app.confirm_payment" })}</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {isLoading && <Loader />}
        </div>

    )
}

export default injectIntl(PaymentConfirmation);
